import { render, staticRenderFns } from "./AxFilesystemNodesActions.vue?vue&type=template&id=2c13e48a&scoped=true&"
import script from "./AxFilesystemNodesActions.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemNodesActions.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemNodesActions.vue?vue&type=style&index=0&id=2c13e48a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c13e48a",
  null
  
)

export default component.exports